import { Component } from '@angular/core';

@Component({
  templateUrl: 'login-layout.component.html',
  styleUrls: ['login-layout.component.scss'],
})
export class LoginLayoutComponent {}
